module.exports = __webpack_public_path__ + "static/media/bf.68e2b678.svg";